import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Button, Form } from "semantic-ui-react";
import { getTranslate } from "react-localize-redux/lib/index";


class Prices extends Component {

    constructor(props) {
        super(props);
        this.state = {
            product: { ...props.product },
        };
    }


    render() {

        const { translate } = this.props;

        return <Form onSubmit={(e) => {
            e.preventDefault();
            this.complete();
        }}>

            {/* Prices */}

            <Form.Input type='number' step='0.000001' min='0.01' label={translate("tools.fields.cost")}
                        value={this.state.product.cost}
                        required
                        onChange={(e) => {
                            this.setState({
                                product: {
                                    ...this.state.product,
                                    cost: e.target.value
                                }
                            });
                        }}
            />

            <Form.Input label={translate("tools.fields.price")}
                        type='number' step='0.000001' min={this.state.product.cost}
                        required
                        value={this.state.product.priceWithVat}
                        onChange={(e) => {
                            this.setState({
                                product: {
                                    ...this.state.product,
                                    priceWithVat: e.target.value
                                }
                            });
                        }}
            />

            {/* Price Lists */}

            {
                this.state.product.price_lists &&
                <div>
                    {this.state.product.price_lists.map((list, key) =>
                        <Form.Input key={key}
                                    type='number' step='0.000001' min={this.state.product.cost}
                                    label={list.name}
                                    value={this.state.product.price_lists[key].pivot.price}
                                    required
                                    onChange={(e) => {
                                        this.setState({
                                            product: {
                                                ...this.state.product,
                                                price_lists: this.state.product.price_lists.map((list, mapKey) => {
                                                    if (key === mapKey) {
                                                        list.pivot.price = e.target.value;
                                                        return list;
                                                    }
                                                    return list;
                                                })
                                            }
                                        });
                                    }}
                        />
                    )}

                </div>
            }


            <Button positive fluid style={{ paddingTop: "10px" }}>Next</Button>


        </Form>;
    }

    complete() {
        this.props.onComplete(this.state.product);
    }


    /**
     *
     * @returns {boolean}
     */
    validate() {

        return true;
    }


}

Prices.propTypes = {
    onComplete: PropTypes.func.isRequired,
    product: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
});


const mapDispatchToProps = (dispatch) => {
    return ({});
};


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Prices);



// WEBPACK FOOTER //
// ./src/scenes/Tools/scenes/MasterDataRequest/components/Steps/Prices/index.js